var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReachIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9 0.771043C14.73 0.771043 14.58 0.861043 14.49 1.00104L14.42 1.15104L9.24 12.801C9.08 13.091 8.98 13.411 8.98 13.761C8.98 14.871 9.88 15.771 10.99 15.771C11.95 15.771 12.76 15.091 12.95 14.181L12.96 14.151L15.4 1.27104C15.4 0.991043 15.18 0.771043 14.9 0.771043ZM0 4.77104L2 6.77104C4.88 3.89104 8.79 2.69104 12.53 3.15104L13.72 0.471043C8.89 -0.388957 3.74 1.04104 0 4.77104ZM20 6.77104L22 4.77104C20.36 3.13104 18.45 1.95104 16.41 1.20104L15.88 4.02104C17.38 4.64104 18.78 5.55104 20 6.77104ZM16 10.771L18 8.77104C17.2 7.97104 16.3 7.35104 15.34 6.88104L14.79 9.80104C15.21 10.071 15.62 10.391 16 10.771ZM4 8.77104L6 10.771C7.13 9.64104 8.56 8.98104 10.03 8.77104L11.31 5.89104C8.68 5.81104 6.01 6.76104 4 8.77104Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReachIcon);
export default __webpack_public_path__ + "static/media/reach-icon.561a67f1db559e1c7a5d6222a81a49fa.svg";
export { ForwardRef as ReactComponent };